import { render, staticRenderFns } from "./jiazhengxianfeng.vue?vue&type=template&id=d7042ba8&scoped=true"
import script from "./jiazhengxianfeng.vue?vue&type=script&lang=js"
export * from "./jiazhengxianfeng.vue?vue&type=script&lang=js"
import style0 from "./jiazhengxianfeng.vue?vue&type=style&index=0&id=d7042ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7042ba8",
  null
  
)

export default component.exports